import React, { createContext, useContext } from 'react';
export const TAB_VARIANTS = ['bar', 'pills', 'pills-accent'];
export const TAB_SIZES = ['sm', 'md'];
const TabsContext = createContext(undefined);
export const TabsProvider = ({ variant, size, fullWidth, children }) => (React.createElement(TabsContext.Provider, { value: {
        variant,
        size,
        fullWidth,
    } }, children));
export const useTabs = () => {
    const context = useContext(TabsContext);
    if (context === undefined) {
        throw new Error('useTabs must be used within a TabsProvider');
    }
    return context;
};
//# sourceMappingURL=TabsContext.js.map